<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="用户ID：" prop="user_id">
                <span>{{model.user_id}}</span>
            </el-form-item>
            <el-form-item label="用户名：" prop="username">
                <span>{{model.username}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="realname">
                <span>{{model.realname}}</span>
            </el-form-item>
            <el-form-item label="机构顶ID：" prop="org_pid">
                <span>{{model.org_pid}}</span>
            </el-form-item>
            <el-form-item label="机构ID：" prop="org_id">
                <span>{{model.org_id}}</span>
            </el-form-item>
            <el-form-item label="机构名称：" prop="org_name">
                <span>{{model.org_name}}</span>
            </el-form-item>
            <el-form-item label="在线时长：" prop="online_time">
                <span>{{model.online_time}}</span>
            </el-form-item>
            <el-form-item label="OCR识别数量：" prop="ocr_count">
                <span>{{model.ocr_count}}</span>
            </el-form-item>
            <el-form-item label="导入报告数量：" prop="import_report_count">
                <span>{{model.import_report_count}}</span>
            </el-form-item>
            <el-form-item label="处置监测报告数量：" prop="deal_report_check_count">
                <span>{{model.deal_report_check_count}}</span>
            </el-form-item>
            <el-form-item label="处置差异报告数量：" prop="deal_report_extract_count">
                <span>{{model.deal_report_extract_count}}</span>
            </el-form-item>
            <el-form-item label="巡检设备数量：" prop="check_device_count">
                <span>{{model.check_device_count}}</span>
            </el-form-item>
            <el-form-item label="数据更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'userMonitorInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                user_id: '',
                username: '',
                realname: '',
                org_pid: '',
                org_id: '',
                org_name: '',
                online_time: '',
                ocr_count: '',
                import_report_count: '',
                deal_report_check_count: '',
                deal_report_extract_count: '',
                check_device_count: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/usermonitor/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>